<template>
  <v-select :items="statOptions" v-model="innerValue" :hint="label" persistent-hint>
    <v-icon slot="append" :color="color">
      {{ icon }}
    </v-icon>
  </v-select>
    <!-- <v-text-field v-model.number="innerValue" :label="label" /> -->
</template>

<script>
  export default {
    name: 'StatField',
    props: ['label', 'value', 'color', 'icon'],
    components: {},
    data() {
      return {
        statOptions: [0,1,2,3,4,5,6,7,8,9,10],
      }
    },
    computed: {
      innerValue: {
        get() {
          return this.$store.state.character.stats[this.value];
        },
        set(val) {
          this.$store.dispatch('character/setStat', {stat: this.value, value: val});
        },
      },
    },

    methods: {},
  };
</script>
